import * as React from 'react';
import { ReportFieldDefinition, ReportFieldFlag } from "../../../../models";
import Typography from '../../../Typography';
import { TextInputField } from '../../fields';

interface SingleLineTextFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    style?: React.CSSProperties,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const SingleLineTextField: React.FC<SingleLineTextFieldProps> = ({
    id,
    value,
    style,
    invalid,
    readOnly,
    onChange,
}) => {
    return readOnly 
        ? <Typography id={id} style={style}>{value}</Typography>
        : <TextInputField id={id} style={style} invalid={invalid} value={value} onChange={onChange} disabled={readOnly}/>
}